<script setup>
/* eslint-disable */
import { ref } from 'vue'
import ranchHandImage from '@/assets/ranch_hand.jpg'

const emit = defineEmits(['close'])
const currentTab = ref(0)

const content = [
  {
    title: "Welcome to Chocobo Racing Manager!",
    text: "Howdy! I'll be your guide as you start your journey as a Chocobo Ranch owner. Let me walk you through the basics of running your ranch and racing your birds.",
    key: "intro"
  },
  {
    title: "Racing Circuits",
    text: "Start with Regional races to build experience. As your chocobos level up, you'll unlock Continental (Level 10), Trans-Continental (Level 20), Global (Level 30), and Gold Saucer (Level 40) circuits. Higher circuits mean bigger prizes - but also tougher competition! You'll be starting in the Regional Circuits with two freshly caught Choco's, but it won't be long before you're turning out birds at the Saucer!",
    key: "circuits"
  },
  {
    title: "Training Your Chocobos",
    text: "Focus on Speed for raw racing power, Stamina for longer races, or Behavior training to improve their temperament. Chocobos with X-Factors have special potential in Speed or Stamina - keep an eye out for those!",
    key: "training"
  },
  {
    title: "Building Your Ranch",
    text: "You can own up to 20 chocobos. Breed them to combine traits, or catch wild ones on expeditions. Trade with other ranches to improve your stable. Remember - a good ranch owner knows when to buy, sell, or hold onto their birds.",
    key: "ranch"
  },
  {
    title: "Making Money",
    text: "You need to keep an eye on your cash or you won't be able to race. If you hit rock bottom, you can let your birds work the day as transit, but you'll miss out on experience when you do that!",
    key: "money"
  }
]

const handleComplete = () => {
  if (currentTab.value < content.length - 1) {
    currentTab.value++
  } else {
    localStorage.setItem('hasSeenRules', 'true')
    emit('close')
  }
}
</script>

<template>
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col">
      <div class="p-6 overflow-y-auto flex-1">
        <!-- Header -->
        <div class="flex justify-between items-start mb-6">
          <div>
            <h2 class="text-2xl font-bold">{{ content[currentTab].title }}</h2>
          </div>
          <div class="flex items-center gap-2">
            <span class="text-sm text-gray-500">
              {{ currentTab + 1 }} of {{ content.length }}
            </span>
          </div>
        </div>

        <!-- Ranch Hand Image and Content -->
        <div class="flex gap-4 mb-6">
          <img 
            :src="ranchHandImage"
            alt="Ranch Hand" 
            class="w-24 h-24 rounded-lg object-cover"
          />
          <div class="flex-1">
            <p class="text-lg">{{ content[currentTab].text }}</p>
          </div>
        </div>

        <!-- Navigation -->
        <div class="flex justify-end gap-2">
          <button
            v-if="currentTab > 0"
            @click="currentTab--"
            class="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg"
          >
            Previous
          </button>
          <button
            @click="handleComplete"
            class="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
          >
            {{ currentTab < content.length - 1 ? 'Next' : 'Start Game' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>